// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"VS-z","categoryName":"WS-z","categoryNameSearchHeader":"XS-z","categoryContent":"YS-z","bottomAligned":"ZS-z","image":"_S-z","imageNoBackground":"aT-z"};